import React, { PureComponent } from "react";
export class NoteIcon extends PureComponent {
  props: Object;
  render() {
    const { ...rest } = this.props;
    return (
      <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" {...rest}>
        <title>Note-32x32</title>
        <desc>Created with Sketch.</desc>
        <defs />
        <g id="Note-32x32" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
          <g id="notes" transform="translate(3.000000, 1.000000)" stroke="#111111" strokeWidth="2">
            <path d="M6.5,13 L19.5,13" id="Shape" />
            <path d="M6.5,18 L19.5,18" id="Shape" />
            <path d="M6.5,23 L11.9166667,23" id="Shape" />
            <path
              d="M16.25,3 C16.25,1.343 14.7950833,0 13,0 C11.2049167,0 9.75,1.343 9.75,3 L6.5,3 L6.5,7 L19.5,7 L19.5,3 L16.25,3 Z"
              id="Shape"
            />
            <polyline id="Shape" points="23.8333333 4 26 4 26 30 0 30 0 4 2.16666667 4" />
          </g>
        </g>
      </svg>
    );
  }
}
export default NoteIcon;



// WEBPACK FOOTER //
// ./src/_icons/NoteIcon/index.js